import { AppThunk, AppDispatch } from '@app/store/store'
import { getGreenhouseJobs } from '@app/api/greenhouse'

import { actions } from './slice'

export const getJobsList = (): AppThunk => async (dispatch: AppDispatch) => {
  dispatch(actions.requestFetchJobs())

  try {
    const response = await getGreenhouseJobs()
    dispatch(actions.successFetchJobs(response))
  } catch (error) {
    dispatch(actions.errorFetchJobs(error.errors?.[0]?.message))
  }
}
